var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLargePreconsentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5994 39.8001C13.3094 39.8001 7.39941 33.8901 7.39941 26.6001C7.39941 19.3101 13.3094 7.40015 20.5994 7.40015C27.8894 7.40015 33.7994 19.3101 33.7994 26.6001C33.7994 33.8901 27.8894 39.8001 20.5994 39.8001Z",
    fill: "#FF4080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1995 37.4002C18.1995 30.1102 24.1095 24.2002 31.3995 24.2002C38.6895 24.2002 50.5995 30.1102 50.5995 37.4002C50.5995 44.6902 38.6895 50.6002 31.3995 50.6002C24.1095 50.6002 18.1995 44.6902 18.1995 37.4002Z",
    fill: "#6236FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargePreconsentIcon);
export default __webpack_public_path__ + "static/media/large-preconsent-icon.a8303e32270efb9d68030e1ad64e923c.svg";
export { ForwardRef as ReactComponent };